import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSelection } from './components/PricingSelection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="w-full min-h-screen bg-marfil font-sans selection:bg-salvia selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ValueStack data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <CountdownTimer data-id="element-9" />
      <PricingSelection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <FooterSection data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
      <MetaPixel data-id="element-14" />
    </main>;
}